import { useHasDocuments } from '~/services/company';
import useAccountingConnectionState from './useAccountingConnectionState';

const useAccountingShouldDoFirstConnection = (): 'loading' | 'first_connection' | 'completed' => {
  const connectionState = useAccountingConnectionState();
  const hasDocuments = useHasDocuments();

  if (connectionState.state === 'loading' || hasDocuments.isLoading) {
    return 'loading';
  }

  switch (connectionState.state) {
    case 'connect':
    case 'connected_waiting':
      return hasDocuments.data ? 'completed' : 'first_connection';
    case 'connected_waiting_with_history':
      return 'completed';
    case 'reconnect':
      if (hasDocuments.data || connectionState.consent.authorizedAt || connectionState.consent.lastRunAt) {
        return 'completed';
      } else {
        return 'first_connection';
      }
    case 'connected':
      return 'completed';
  }
};

export default useAccountingShouldDoFirstConnection;
